export { WildCashbackIcon } from './WildCashbackIcon';
export { WildCashbackSimpleIcon } from './WildCashbackSimpleIcon';
